import { Component, OnDestroy, OnInit } from '@angular/core';
import { CookieService } from 'ng2-cookies';
import { Ng2SmartTableComponent } from 'ng2-smart-table';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { SecurityService } from '../../services/security.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';
import { ButtonsCatalogViewComponent } from './buttons-catalog-view/buttons-catalog-view.component';
import { getCountryLabel } from '../../utility/country.util';

@Component({
  selector: 'app-catalog-view',
  templateUrl: './catalog-view.component.html',
  styleUrls: ['./catalog-view.component.css']
})
export class CatalogViewComponent implements OnInit, OnDestroy {

  settings = {
    actions: {
      add: false,
      edit:false,
      delete:false
      },
    columns: {
    
      globalCustomerName: {
        title: 'Global Customer Name'
      },
      country: {
        title: 'Country',
        valuePrepareFunction: (country: string) => {
          return getCountryLabel(country);
        }
      },
      localCustomer: {
        title: 'Local Customer'
      },
      localCustomerName: {
        title: 'Local Customer Name'
      },
      catalogName: {
        title: 'Catalog Name'
      },
      lead: {
        title: 'Lead Operator'
      },
      owner: {
        title: 'B Operator'
      },
      button: {
        title: 'View More',
        type: 'custom',
        renderComponent: ButtonsCatalogViewComponent,
        filter:false,
        sort:false
      }


    },
    pager: {
      display: false
    }
  };

  listCatalog: any[] =[];
  listCatalogAdds: any[] = [];
  destroy$ = new Subject<boolean>();

  constructor(private networkService: NetworkService, private toastr: ToastrManager, 
    private spinner: NgxSpinnerService, private securityService: SecurityService) { }

  ngOnInit(): void {
    this.initializeListCatalog();
    
  }

  initializeListCatalog() {

    this.spinner.show("sp1");
    let urlCatalog: string = environment.basePath + _ENDPOINT.getAllCatalog;
    let request = {
      lastId: "",
      lastTimeStamp: "",
      limit:"50"
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlCatalog, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listCatalog = JSON.parse(response.body);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && Array.isArray(response)) {
            this.listCatalog = response;
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length>0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Catalogs Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Catalogs Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  loadMoreCatalogs(){
    if(this.listCatalog && this.listCatalog.length>0){
      let catalog: any = this.listCatalog[this.listCatalog.length-1];
      this.loadOtherCatalog(catalog);
    }
  }

  loadOtherCatalog(catalog: any) {

    this.spinner.show("sp1");
    let urlCatalog: string = environment.basePath + _ENDPOINT.getAllCatalog;
    let request = {
      lastId: catalog.catalogId,
      lastTimeStamp: catalog.createdAt,
      limit:"50"
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlCatalog, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listCatalogAdds = JSON.parse(response.body);
            this.listCatalog = this.listCatalog.concat(this.listCatalogAdds);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && Array.isArray(response)) {
            this.listCatalogAdds = response;
            this.listCatalog = this.listCatalog.concat(this.listCatalogAdds);
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length>0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Catalogs Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Catalogs Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  viewLoadMoreCatalog(){
    if(this.listCatalog && this.listCatalog.length>0){
      return true;
    }else{
      return false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
